import { Notify } from "quasar";

export class Feedback {
  static success(msg = "Sucesso") {
    let message = msg;

    Notify.create({
      message: message,
      color: "green-10",
      icon: "mdi-check-circle",
    });
  }

  static error(msg = "Erro") {
    let message = msg;

    Notify.create({
      message: message,
      color: "red-10",
      icon: "mdi-close-circle",
    });
  }

  static warning(msg = "Alerta") {
    Notify.create({
      message: msg,
      color: "yellow-10",
      icon: "mdi-alert-circle",
    });
  }
}
